import { destroy as destroyRF } from 'redux-form'
import { destroy as destroySFM } from 'loankeeper-common/helpers/SimpleFetchManager'
import { destroy as destroyLKG } from '../shared/LKGrid'
import { RF_NAME, LK_GRID_NAME, LOANS_FETCHER_NAME } from './constants'
import { destroyLoans } from 'src/store/loan'

export const closeLoanGrid = () => destroyLKG(LK_GRID_NAME)

export const destroyLoanSearchForm = () => destroyRF(RF_NAME)

// export const deleteLoans = () => destroySFM(LOANS_FETCHER_NAME)
export const deleteLoans = () => destroyLoans()

export const destroy = () => [closeLoanGrid(), destroyLoanSearchForm(), deleteLoans()]
